/**
 * Deprecated module with data schemas
 * @deprecated
 */
angular.module('softwear.schemas', []).constant('schemas', {
  // used by admin
  buffer: require('./spynl/buffer.json'),
  customer: require('./spynl/customer.json'),
  eos: require('./spynl/eos.json'),
  event: require('./spynl/event.json'),
  receivings: require('./spynl/receiving/receiving.json'),

  shared: [
    require('./spynl/shared/address.json'),
    require('./spynl/shared/amounts.json'),
    require('./spynl/shared/campaigns.json'),
    require('./spynl/shared/contact.json'),
    require('./spynl/shared/interaction.json'),
    require('./spynl/shared/mongo_id.json'),
    require('./spynl/receiving/receiving_product.json'),
  ],
});
